<div class="coupon-metadata-form">
  <form [formGroup]="form" (ngSubmit)="generateMetadata()">
      <div class="row" formGroupName="it">
          <h4 class="vox-heading-4" translate>marketing.offer-link.metadata-form.title</h4>
          <h5 class="vox-heading-5" translate>marketing.offer-link.metadata-form.it.lang</h5>
          <div class="col-sm-12">
              <label for="title-it" translate>marketing.offer-link.metadata-form.it.title.label</label>
              <div class="vox-input-group vox-input-group_dense"
                [ngClass]="{'vox-input-group_invalid': isFieldInvalid('title', 'it') }">
                  <input class="vox-text-field" type="text" id="title-it" formControlName="title"
                    [placeholder]="'marketing.offer-link.metadata-form.it.title.placeholder' | translate"/>
                  <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
                  <span class="vox-input-group__error-message" translate>marketing.offer-link.metadata-form.required</span>
              </div>
          </div>
          <div class="col-sm-12">
              <label for="subtitle-it" translate>marketing.offer-link.metadata-form.it.subtitle.label</label>
              <div class="vox-input-group vox-input-group_dense"
                  [ngClass]="{'vox-input-group_invalid': isFieldInvalid('subtitle', 'it') }">
                  <input class="vox-text-field" type="text" id="subtitle-it"
                    [placeholder]="'marketing.offer-link.metadata-form.it.subtitle.placeholder' | translate"
                    formControlName='subtitle' />
                  <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
                  <span class="vox-input-group__error-message" translate>marketing.offer-link.metadata-form.required</span>
              </div>
          </div>
          <div class="col-sm-12">
            <label for="cta-it" translate>marketing.offer-link.metadata-form.it.cta.label</label>
            <div class="vox-input-group vox-input-group_dense"
                [ngClass]="{'vox-input-group_invalid': isFieldInvalid('cta', 'it') }">
                <input class="vox-text-field" type="text" id="cta-it"
                  [placeholder]="'marketing.offer-link.metadata-form.it.cta.placeholder' | translate"
                  formControlName='cta' />
                <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
                <span class="vox-input-group__error-message" translate>marketing.offer-link.metadata-form.required</span>
            </div>
          </div>
      </div>
      <div class="row" formGroupName="en">
        <h5 class="vox-heading-5" translate>marketing.offer-link.metadata-form.en.lang</h5>
        <div class="col-sm-12">
          <label for="title-en" translate>marketing.offer-link.metadata-form.en.title.label</label>
          <div class="vox-input-group vox-input-group_dense"
              [ngClass]="{'vox-input-group_invalid': isFieldInvalid('title', 'en') }">
              <input class="vox-text-field" type="text" id="title-en"
                [placeholder]="'marketing.offer-link.metadata-form.en.title.placeholder' | translate"
                formControlName='title' />
              <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
              <span class="vox-input-group__error-message" translate>marketing.offer-link.metadata-form.required</span>
          </div>
        </div>
        <div class="col-sm-12">
          <label for="subtitle-en" translate>marketing.offer-link.metadata-form.en.subtitle.label</label>
          <div class="vox-input-group vox-input-group_dense"
              [ngClass]="{'vox-input-group_invalid': isFieldInvalid('subtitle', 'en') }">
              <input class="vox-text-field" type="text" id="subtitle-en"
                [placeholder]="'marketing.offer-link.metadata-form.en.subtitle.placeholder' | translate"
                formControlName='subtitle' />
              <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
              <span class="vox-input-group__error-message" translate>marketing.offer-link.metadata-form.required</span>
          </div>
        </div>
        <div class="col-sm-12">
          <label for="cta-en" translate>marketing.offer-link.metadata-form.en.cta.label</label>
          <div class="vox-input-group vox-input-group_dense"
              [ngClass]="{'vox-input-group_invalid': isFieldInvalid('cta', 'en') }">
              <input class="vox-text-field" type="text" id="cta-en"
                [placeholder]="'marketing.offer-link.metadata-form.en.cta.placeholder' | translate"
                formControlName='cta' />
              <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
              <span class="vox-input-group__error-message" translate>marketing.offer-link.metadata-form.required</span>
          </div>
        </div>
      </div>
      <div class="submit-container">
          <button class="vox-btn vox-btn-primary" [disabled]="form.invalid" type="submit" translate>
            marketing.offer-link.metadata-form.submit
          </button>
      </div>
  </form>
</div>
